import { each, forEach, get } from 'lodash-es'
import { storageKey, } from '@/utils/conf'
import { ElMessage } from "element-plus";
import { computed } from "vue";
import router from "@/router";

/**
 * 设置获取Store 的内容
 * @param {string|array} key
 * @param val?
 * @returns
 */
export const localStore = (key, val = undefined) => {
    /**
     * localStorage内存溢出时，则清空后继续保存
     */
    let _localStorageOverflow = (key, data) => {
        try {
            localStorage.setItem(key, data)
        } catch (e) {
            // 当缓存溢出，则清空后继续保存
            if (e.code === 'QUOTA_EXCEEDED_ERR_CODE') {
                localStorage.removeItem(key)
                localStorage.setItem(key, data)
            } else {
                console.error(e)
            }
        }
    }

    // 本地数据存储封装，没有过期时间限制，仅限于该页面的协议
    if (val === null) {
        if (typeof key === 'object') {
            each(key, function (ele, idx) {
                _localStorageOverflow(idx, ele) // 存储数据
            })
            return
        } else {
            localStorage.removeItem(key) // 移除数据
            return
        }
    }
    if (typeof val === 'undefined') {
        let data = localStorage.getItem(key)
        if (data) {
            try {
                return JSON.parse(data)
            } catch (err) {
                return data // 获取数据
            }
        }
        return data // 获取数据
    }
    if (typeof val === 'object') {
        _localStorageOverflow(key, JSON.stringify(val))
    } else {
        _localStorageOverflow(key, val)
    }
}

/**
 * 实现sessionStorage缓存的 存, 取, 删操作
 * @param key 对象, 批量设置
 * @param val 有值:设置; 无值: 获取; null, 删除;
 */
export const sessionStore = (key, val) => {
    // 本地数据存储封装，随页面回话结束而结束，仅限于该页面的协议
    if (val === null) {
        if (typeof key === 'object') {
            forEach(key, function (ele, idx) {
                sessionStorage.setItem(idx, ele)
            })
            return
        } else {
            sessionStorage.removeItem(key)
            return
        }
    }
    if (typeof val === 'undefined') {
        let data = sessionStorage.getItem(key)
        if (data) {
            try {
                data = JSON.parse(data)
                return data // 获取数据
            } catch (err) {
                return sessionStorage.getItem(key) // 获取数据
            }
        }
        return data // 获取数据
    }
    if (typeof val === 'object') {
        sessionStorage.setItem(key, JSON.stringify(val))
    } else {
        sessionStorage.setItem(key, val)
    }
}

/**
 * 将时间格式化为 H:m:s
 * @param num
 * @returns {string}
 */
export const secondsToHms = (num) => {
    let h = Math.floor(num / 3600)
    let m = Math.floor((num / 60) % 60)
    let s = Math.floor(num % 60)
    return (
        (h > 9 ? h : '0' + h) +
        ':' +
        (m > 9 ? m : '0' + m) +
        ':' +
        (s > 9 ? s : '0' + s) +
        ''
    )
}



export const testRunningSeconds = () => {
    return localStore(storageKey.TEST_RUNNING_SECOND)
        ? Number(localStore(storageKey.TEST_RUNNING_SECOND))
        : 0
}

/**
 * 清空 localStorage
 */
export const clearLocalStorage = () => {
    localStorage.clear()
}

/**
 * 错误提示
 * @param message
 * @param success
 */
export const toast = (message: string, success: boolean = false) => {
    if (success) {
        ElMessage.success(message)
    } else {
        ElMessage.warning(message);
    }
}

export const isMock = computed(() => Boolean(get(router.currentRoute.value.query, 'mock')))